import StylishStat from "./StylishStat.component";
import { useState, useEffect } from "react";
import axios from "axios";
import { nFormatter } from "@misc/Helpers";

const GangstaverseStat = () => {
  const [statData, setStatData] = useState([]);

  useEffect(() => {
    (async () => {
      const { data: emeraldStatData } = await axios.get(
        `${process.env.REACT_APP_CRAFT_URL}/${process.env.REACT_APP_EMERALD_CONTRACT_ADDRESS}`
      );
      const { data: craftStatData } = await axios.get(
        `${process.env.REACT_APP_CRAFT_URL}/${process.env.REACT_APP_GANGSTABET_CONTRACT_ADDRESS}`
      );
      const { data: goldenkeyStatData } = await axios.get(
        `${process.env.REACT_APP_CRAFT_URL}/${process.env.REACT_APP_GOLDENKEY_CONTRACT_ADDRESS}`
      );
      const { data: gangstabetStatData } = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/transactionAnalytics`
      );
      const gangstaStat =
        Number(gangstabetStatData.gangsta_marketplace.total_volume_traded) +
        Number(craftStatData.data.primary_asset_contracts.overallStat.volume);
      const tempStatData: any = [
        {
          title: "Gangstabet",
          value: nFormatter(gangstaStat),
        },

        {
          title: "Golden key",
          value: nFormatter(
            goldenkeyStatData.data.primary_asset_contracts.overallStat.volume
          ),
        },
        {
          title: "Land certificate",
          value: nFormatter(
            emeraldStatData.data.primary_asset_contracts.overallStat.volume
          ),
        },
      ];

      setStatData(tempStatData);
    })();
  }, []);
  return (
    <div className="gangstaverse-stat-bg ">
      <div className="gangstaverse-stat-wrapper">
        <div className="gangstaverse-land-heading wow animate__animated animate__fadeInUp animate-duration-1s">
          Volume Traded
        </div>

        <div className="gangstaverse-stat-details ">
          {statData.length !== 0 &&
            statData?.map((stat: any, index: any) => (
              <StylishStat title={stat.title} value={stat.value} key={index} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default GangstaverseStat;
